<app-side-top-bar [navigationItems]="navigationItems">
  <main class="invoices-sales">
    <section class="sales-section">
      <header class="header">
        <h2>{{ labelService.getLabel("Fatturato") }}</h2>
      </header>
      @if (!isLoading && availableYears.length > 0) {
        <div class="year-selector">
          <span>Seleziona anno: </span>
          <select
            [ngModel]="selectedYear"
            (ngModelChange)="onYearChange($event)"
          >
            @for (year of availableYears; track year) {
              <option [value]="year">
                {{ year }}
              </option>
            }
          </select>
        </div>
      }

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (!isLoading) {
        <div class="section-container">
          <!-- Totals Section -->
          <section class="left-side">
            <section class="table-section">
              <div class="total-row">
                <span class="label">Totale SDI:</span>
                <span class="value">{{ totalSDIInvoices }} €</span>
              </div>
              <div class="total-row">
                <span class="label">Totale STS:</span>
                <span class="value">{{ totalSTSInvoices }} €</span>
              </div>
              <div class="total-row">
                <span class="label">Totale:</span>
                <span class="value">{{ totalInvoices }} €</span>
              </div>
            </section>
            <!-- Add Pie Chart -->
            <section class="chart-section" [class.hidden]="totalInvoices === 0">
              <canvas #pieChart></canvas>
            </section>
          </section>
        </div>
      }
    </section>
  </main>
</app-side-top-bar>
